import React from 'react';

import { Source, Layer } from 'react-map-gl';

import { selectedPathSection } from '../../mapStyles';

const featureLineStyle = selectedPathSection();

export const FeatureLine = ({feature}) => {

  return (
    <Source id='selected_line_feature' type="geojson" data={feature}>
      <Layer id='selected_line_feature' {...featureLineStyle}/>
    </Source>
  );
};